// removed by extract-text-webpack-plugin
module.exports = {"root":"AccordionItemBody__root___2LTbC","wrapper":"AccordionItemBody__wrapper___FcDEo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseAccordion/AccordionItemBody/AccordionItemBody.scss
// module id = 1001
// module chunks = 0